import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import Select from "react-select";
import PhoneInput from "react-phone-number-input";
import Dropzone from "react-dropzone";
import ProfileImage from "components/profileImage";
import { createImageUrl } from "services/imageUrl.service";
import { Formik, Form } from "formik";
import SweetAlert from "react-bootstrap-sweetalert";
import { CreateUserAdmin, EditUseDetailsAdmin } from "services/auth.service";
const defaultValues = {
  firstname: "",
  lastname: "",
  gender: "",
  userImage: "",
  mobilenumber: "",
  email: "",
  role: "",
  adminRole: "",
  status: "",
};
const CreateUser = ({ toggle, modal, ActiveUser,reload }) => {
  const [selectedStatus, setSelectedStatus] = useState({});
  const [selectedRole, setSelectedRole] = useState({});
  const [selectedAdminRole, setSelectedAdminRole] = useState({});
  const [userImage, setUserImage] = useState("");
  const [selectedGender, setSelectedGender] = useState({});
  const [loading, setLoading] = useState(false);
  const [success_msg, setsuccess_msg] = useState(false);
  const [error_msg, seterror_msg] = useState(false);
  const [values, setValues] = useState(defaultValues);
  const initialValues = ActiveUser
    ? { ...defaultValues, ...ActiveUser }
    : defaultValues;
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
  const StatusList = [
    {
      label: "Pending",
      value: "pending",
    },
    {
      label: "Confirmed",
      value: "confirmed",
    },
    {
      label: "Deativated",
      value: "deactivated",
    },
  ];
  const GenderList = [
    {
      label: "Male",
      value: "Male",
    },
    {
      label: "Female",
      value: "Female",
    },
  ];
  const UsersRolesList = [
    {
      label: "Admin",
      value: "Admin",
    },
    {
      label: "Customer",
      value: "Customer",
    },
    {
      label: "Support",
      value: "Support",
    },
    {
      label: "Employee",
      value: "Employe",
    },
  ];
  const AdminRolesList = [
    {
      label: "Super",
      value: "super",
    },
    {
      label: "FrontDesk",
      value: "frontDesk",
    },
    {
      label: "SupportDesk",
      value: "supportDesk",
    },
    {
      label: "Manager",
      value: "manager",
    },
    {
      label: "Accountant",
      value: "accountant",
    },
  ];
  const handleImageChange = async image => {
    try {
      let imageFormData = new FormData();
      imageFormData.set("image", image);

      const data = await createImageUrl(imageFormData);

      if (data.success) {
        return data?.image;
      }
    } catch (err) {
      console.log(err);
    }
  };
  const saveChanges = values => {
    let payload = {
      ...values,
      userImage: userImage,
    };
    console.log(payload, "values ");
    setLoading(true);
    CreateUserAdmin(payload)
      .then(res => {
        if (res?.success === true) {
          setsuccess_msg(true);
          reload()
        } else {
          seterror_msg(true);
        }
        setLoading(false);
        // reload();
      })
      .catch(e => {
        console.log(e);
        seterror_msg(true);
        setLoading(false);
      });
  };

  const editChanges = values => {
    let payload = {
      ...values,
      userImage: userImage,
    };
    console.log(payload, "values ");
    setLoading(true);
    EditUseDetailsAdmin(ActiveUser?._id,payload)
      .then(res => {
        if (res?.success === true) {
          setsuccess_msg(true);
          reload()
        } else {
          seterror_msg(true);
        }
        setLoading(false);
        // reload();
      })
      .catch(e => {
        console.log(e);
        seterror_msg(true);
        setLoading(false);
      });
  };

  const leaveToList = () => {
    toggle();
    setsuccess_msg(false);
    seterror_msg(false);
  };
  const stayHere = () => {
    setsuccess_msg(false);
    seterror_msg(false);
  };

  const successPopup = () => {
    return (
      <SweetAlert
        title="Success"
        success
        onConfirm={leaveToList}
        onCancel={stayHere}
        customButtons={
          <React.Fragment>
            <Button
              color="primary"
              className="w-md btn-sm mx-1"
              onClick={leaveToList}
            >
              Leave
            </Button>
            <Button
              color="light"
              className="w-md btn-sm mx-1"
              onClick={stayHere}
            >
              Continue
            </Button>
          </React.Fragment>
        }
      >
        {ActiveUser?._id
          ? "Successfully user details update"
          : "Successfully user created"}
      </SweetAlert>
    );
  };

  const errorPopup = () => {
    return (
      <SweetAlert
        title="Failure"
        danger
        onConfirm={leaveToList}
        onCancel={stayHere}
        customButtons={
          <React.Fragment>
            <Button
              color="light"
              className="w-md btn-sm mx-1"
              onClick={leaveToList}
            >
              Leave
            </Button>
            <Button
              color="danger"
              className="w-md btn-sm mx-1"
              onClick={stayHere}
            >
              Continue
            </Button>
          </React.Fragment>
        }
      >
        Something went wrong
      </SweetAlert>
    );
  };
  return (
    <>
      <Modal isOpen={modal} toggle={toggle} backdrop="static" size="lg">
        <ModalHeader toggle={toggle}>
          <div className="d-flex align-items-center">
            <h5 className="fw-bold text-uppercase mb-0">
              {ActiveUser ? "Edit User" : "Create user"}
            </h5>
          </div>
        </ModalHeader>
        <ModalBody className="bg-light">
          <Container fluid>
            <div>
              <Card>
                <CardBody>
                  <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    // validationSchema={validationSchema}
                  >
                    {({
                      errors,
                      touched,
                      isSubmitting,
                      setFieldValue,
                      handleChange,
                      setFieldTouched,
                      values,
                    }) => {
                      useEffect(() => {
                        if (ActiveUser?._id) {
                          setSelectedRole({
                            label: ActiveUser?.role,
                            value: ActiveUser?.role,
                          });
                          setSelectedStatus({
                            label: ActiveUser?.status,
                            value: ActiveUser?.status,
                          });
                          setSelectedAdminRole({
                            label: ActiveUser?.adminRole,
                            value: ActiveUser?.adminRole,
                          });
                          setSelectedGender({
                            label: ActiveUser?.gender,
                            value: ActiveUser?.gender,
                          });
                          setUserImage(
                            ActiveUser?.userImage ? ActiveUser?.userImage : ""
                          );
                        }
                      }, []);

                      return (
                        <Form>
                          <Row>
                            <Col md={4}>
                              <FormGroup>
                                <Label for="firstname">
                                  First Name{" "}
                                  <span className="text-danger">*</span>
                                </Label>
                                <Input
                                  type="text"
                                  name="firstname"
                                  id="firstname"
                                  placeholder="First name"
                                  value={values?.firstname}
                                  onChange={event => {
                                    handleChange("firstname")(
                                      event.target.value
                                    );
                                  }}
                                />
                              </FormGroup>
                            </Col>
                            <Col md={4}>
                              <FormGroup>
                                <Label for="lastname">Last Name</Label>
                                <Input
                                  type="text"
                                  name="lastname"
                                  id="lastname"
                                  placeholder="Last name"
                                  value={values?.lastname}
                                  onChange={event => {
                                    handleChange("lastname")(
                                      event.target.value
                                    );
                                  }}
                                />
                              </FormGroup>
                            </Col>
                            <Col md={4}>
                              <FormGroup>
                                <Label for="email">
                                  Email <span className="text-danger">*</span>
                                </Label>
                                <Input
                                  type="text"
                                  name="email"
                                  id="email"
                                  placeholder="Email"
                                  value={values?.email}
                                  onChange={event => {
                                    handleChange("email")(event.target.value);
                                  }}
                                />
                              </FormGroup>
                            </Col>
                            <Col sm={4}>
                              <Label
                                htmlFor="mobilenumber"
                                className="col-form-label"
                              >
                                Mobile Number{" "}
                                <span className="text-danger">*</span>
                              </Label>

                              <PhoneInput
                                className="custom_country_phoneNumber"
                                id="mobilenumber"
                                placeholder="mobile number"
                                name="mobilenumber"
                                international={false}
                                defaultCountry={"IN"}
                                value={values?.mobilenumber}
                                onChange={event => {
                                  // handleChange("mobilenumber")(event);
                                  setFieldValue("mobilenumber", event);
                                }}
                              />
                            </Col>
                            <Col md={4}>
                              <FormGroup className="status_form_group mt-2">
                                <Label for="Status">
                                  Status <span className="text-danger">*</span>
                                </Label>
                                <Select
                                  name="Status"
                                  id="Status"
                                  value={selectedStatus}
                                  placeholder="Select..."
                                  onChange={event => {
                                    // handleSelectCouponStatus(event);
                                    handleChange("status")(event.value);
                                    setSelectedStatus(event);
                                  }}
                                  options={StatusList}
                                />
                              </FormGroup>
                            </Col>
                            <Col md={4}>
                              <FormGroup className="status_form_group mt-2">
                                <Label for="gender">
                                  Gender <span className="text-danger">*</span>
                                </Label>
                                <Select
                                  name="gender"
                                  id="gender"
                                  value={selectedGender}
                                  placeholder="Select..."
                                  onChange={event => {
                                    // handleSelectCouponStatus(event);
                                    handleChange("gender")(event.value);
                                    setSelectedGender(event);
                                  }}
                                  options={GenderList}
                                />
                              </FormGroup>
                            </Col>
                            <Col md={4}>
                              <FormGroup className="status_form_group mt-2">
                                <Label for="role">
                                  Role <span className="text-danger">*</span>
                                </Label>
                                <Select
                                  name="role"
                                  id="role"
                                  value={selectedRole}
                                  placeholder="Select..."
                                  onChange={event => {
                                    handleChange("role")(event.value);
                                    setSelectedRole(event);
                                  }}
                                  options={UsersRolesList}
                                />
                              </FormGroup>
                            </Col>
                            <Col md={4}>
                              <FormGroup className="status_form_group mt-2">
                                <Label for="adminRole">
                                  Admin Role{" "}
                                  <span className="text-danger">*</span>
                                </Label>
                                <Select
                                  name="adminRole"
                                  id="adminRole"
                                  value={selectedAdminRole}
                                  placeholder="Select..."
                                  onChange={event => {
                                    handleChange("adminRole")(event.value);
                                    setSelectedAdminRole(event);
                                  }}
                                  options={AdminRolesList}
                                />
                              </FormGroup>
                            </Col>
                            {/* <Col md={4} className="mt-2">
                              <FormGroup>
                                <Label for="password">Password</Label>
                                <Input
                                  type="password"
                                  name="password"
                                  id="password"
                                  placeholder="Password"
                                  value={values?.password}
                                  onChange={event => {
                                    handleChange("password")(
                                      event.target.value
                                    );
                                  }}
                                />
                              </FormGroup>
                            </Col> */}
                            <Col md={6} className="mt-2">
                              <FormGroup className="mb-3">
                                <Label htmlFor="validationCustom06">
                                  User image
                                </Label>
                                <Dropzone
                                  id="validationCustom06"
                                  onDrop={async acceptedFiles => {
                                    const formattedFiles = acceptedFiles.map(
                                      file =>
                                        Object.assign(file, {
                                          preview: URL.createObjectURL(file),
                                          formattedSize: formatBytes(file.size),
                                        })
                                    );

                                    if (formattedFiles.length > 0) {
                                      const file = acceptedFiles[0];
                                      try {
                                        const imageUrl =
                                          await handleImageChange(file);
                                        setUserImage(imageUrl);
                                      } catch (error) {
                                        console.error(
                                          "Error creating image URL:",
                                          error
                                        );
                                      }
                                    }
                                  }}
                                >
                                  {({ getRootProps, getInputProps }) => (
                                    <div className="dropzone image_drop">
                                      <div
                                        className="dz-message needsclick"
                                        {...getRootProps()}
                                      >
                                        <input {...getInputProps()} />
                                        <div className="">
                                          <i className="display-6 text-muted bx bxs-cloud-upload" />
                                        </div>
                                        <h6>
                                          Drop files here or click to upload.
                                        </h6>
                                      </div>
                                    </div>
                                  )}
                                </Dropzone>

                                <div
                                  className="dropzone-previews mt-3"
                                  id="file-previews"
                                >
                                  {userImage && (
                                    <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                                      <div className="p-2">
                                        <Row className="align-items-center">
                                          <Col className="col-auto">
                                            <ProfileImage
                                              image={userImage}
                                              height="80"
                                              classNames="avatar-sm rounded bg-light"
                                            />
                                          </Col>
                                        </Row>
                                      </div>
                                    </Card>
                                  )}
                                </div>
                              </FormGroup>
                            </Col>
                            <hr></hr>
                            <div className="d-flex justify-content-end">
                              <Button
                                color="light"
                                className="w-md btn-sm me-3"
                                onClick={leaveToList}
                              >
                                cancel
                              </Button>
                              {!ActiveUser?._id ? (
                                <Button
                                  color="primary"
                                  type="submit"
                                  className="w-md btn-sm"
                                  onClick={() => saveChanges(values)}
                                >
                                  Submit
                                </Button>
                              ) : (
                                <Button
                                  color="primary"
                                  className="w-md btn-sm"
                                  type="submit"
                                  onClick={() => editChanges(values)}
                                >
                                  Save Changes
                                </Button>
                              )}
                            </div>
                          </Row>
                        </Form>
                      );
                    }}
                  </Formik>
                </CardBody>
              </Card>
            </div>
          </Container>
        </ModalBody>
      </Modal>
      {success_msg ? successPopup() : null}
      {error_msg ? errorPopup() : null}
    </>
  );
};

export default CreateUser;
